/* global axios */
import ApiClient from './ApiClient';

/**
 * A client for the Weast AI assistant API.
 * @extends ApiClient
 */
class WeastAPI extends ApiClient {
  /**
   * Creates a new WeastAPI instance.
   */
  constructor() {
    super('weast', { accountScoped: true });
  }

  /**
   * Sends a message to Weast and returns the answer.
   * @param {string} message - The agent's question.
   * @param {string} [conversationId] - The Weast conversation id for follow-up continuity.
   * @returns {Promise} A promise resolving to { message, conversation_id }.
   */
  chat(message, conversationId = '') {
    return axios.post(`${this.url}/chat`, {
      message,
      conversation_id: conversationId,
    });
  }
}

export default new WeastAPI();
